<template>
  <div>
    <TitleFrom
      mode="add"
      :isLoading="isLoading"
      :item="item"
      @cancel="cancel"
      @submit="save"
      :permissions="permissions"
    />
  </div>
</template>

<script>
import TitleFrom from "./../from/titleFrom";
export default {
  name: "add-question-title",
  inject: ["titleRepository"],
  components: {
    TitleFrom,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async finalSave() {
      try {
        if (this.responseCode.length == 0) return;
        let payload = {
          data: [],
        };
        let resize_avatar = false;
        for (const item of this.responseCode) {
          if (item.type.match("image")) {
            if (this.keyServies == "person") {
              resize_avatar = true;
            }
          }
          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
          });
        }
        let actionResource = "exercise";
        let actionkey = this.attachmentId;
        const result = await this.attachmentRepository.create(
          payload,
          actionResource,
          actionkey
        );
        this.afterSave();
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async save(payload) {
      this.isLoading = true;
      try {
        const response = await this.titleRepository.create(payload);
        this.$notify.success(response.data.message);
        this.$emit("getItems");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

